<template>
    <el-row :gutter="12" class="grid-stack-item">
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="header">
                    <h1>{{ $t('Patenkinder Details') }}</h1>
                </div>
                <div class="my-content">
                    <div class="grid-stack-item-content">
                        <div class="card-row">
                            <div class="action-list">
                                <label for="status" :class="(patenkindDetails.status == 'active'? 'act': 'in-act')">{{
                                    $t(patenkindDetails.status) }}</label>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Patenkinder Name') }}</h3>
                                <p>{{ patenkindDetails.display_name }}</p>
                            </div>
                        </div>
                        <div class="card-row">
                            <div class="left-border-list">
                                <h3>{{ $t('Initials of the godchild (e.g. A.Z.)') }}</h3>
                                <p>{{ patenkindDetails.nick_name }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Address') }}</h3>
                                <p>{{ patenkindDetails.address }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Place') }}</h3>
                                <p>{{ patenkindDetails.place }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Zipcode') }}</h3>
                                <p>{{ patenkindDetails.zipcode }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('DOB') }}</h3>
                                <p><span v-date-format="patenkindDetails.dob"></span></p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Age') }}</h3>
                                <p>{{ patenkindDetails.age }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Gender') }}</h3>
                                <p>{{ patenkindDetails.gender }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Legal representatives') }}</h3>
                                <p>{{ patenkindDetails.legal_parent_name }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Legal representatives relation') }}</h3>
                                <p v-ucfirst="patenkindDetails.legal_parent_type"></p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Life situation') }}</h3>
                                <p v-ucfirst="patenkindDetails.life_situation"></p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Origin country') }}</h3>
                                <p>{{ patenkindDetails.origin_country }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Admission') }}</h3>
                                <p><span v-date-format="patenkindDetails.updated_at"></span></p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Leaving') }}</h3>
                                <p><span v-date-format="patenkindDetails.leaving" v-if="patenkindDetails.leaving"></span><span v-else>-</span></p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Fachstellen Name') }}</h3>
                                <p>{{ patenkindDetails.fachstellen_name }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Fachstellen type') }}</h3>
                                <p>{{ patenkindDetails.fachstellen_type_name }}</p>
                            </div>
                            <div class="left-border-list">
                                <h3>{{ $t('Publication') }}</h3>
                                <p><span v-ucfirst="patenkindDetails.publication_type"></span></p>
                            </div>
                            <div class="left-border-list full-list">
                                    <h3>{{ $t('Remarks of the Office') }}</h3>
                                    <p>{{ patenkindDetails.office_comments }}</p>
                                </div>
                            <div class="left-border-list full-list" v-if="patenkindDetails.publication_type == 'other'">
                                <h3>{{ $t('Publication Description') }}</h3>
                                <p v-html="$options.filters.nl2br(patenkindDetails.publication_description)"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="patenkindDetails.description">
                <div class="header">
                    <h1>{{ $t('Description') }}</h1>
                </div>
                <div class="my-content">
                    <div class="grid-stack-item-content">
                        <div class="card-row">
                            <div class="left-border-list full-list">
                                <p v-html="$options.filters.nl2br(patenkindDetails.description)"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="header">
                    <h1>{{ $t('Admission criteria') }}</h1>
                </div>
                <div class="my-content">
                    <div class="grid-stack-item-content">
                        <div class="card-row">
                            <div class="left-border-list full-list">
                                <h3>{{ $t('The godchild is younger than 17 years or has no income (from profession or teaching)') }}</h3>
                                <p>
                                    <el-tag :type="patenkindDetails.q_ans_1 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(patenkindDetails.q_ans_1)" size="mini"></el-tag>
                                </p>
                            </div>
                            <div class="left-border-list full-list">
                                <h3>{{ $t('Application and supervision of sponsorship / support services are provided by the department?') }}</h3>
                                <p>
                                    <el-tag :type="patenkindDetails.q_ans_2 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(patenkindDetails.q_ans_2)" size="mini"></el-tag>
                                </p>
                            </div>
                            <div class="left-border-list full-list">
                                <h3>{{ $t('It is pursued with the godchild a longer-term goal. (Recurring Benefits)') }}</h3>
                                <p>
                                    <el-tag :type="patenkindDetails.q_ans_3 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(patenkindDetails.q_ans_3)" size="mini"></el-tag>
                                </p>
                            </div>
                            <div class="left-border-list full-list">
                                <h3>{{ $t('It can be ensured that the respective support lines exclusively benefit the child.') }}</h3>
                                <p>
                                    <el-tag :type="patenkindDetails.q_ans_4 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(patenkindDetails.q_ans_4)" size="mini"></el-tag>
                                </p>
                            </div>
                            <div class="left-border-list full-list">
                                <h3>{{ $t('There are/were no conflicts with authorities or public bodies.') }}</h3>
                                <p>
                                    <el-tag :type="patenkindDetails.q_ans_5 == 'yes' ? 'success' : 'danger'" v-ucfirst="$t(patenkindDetails.q_ans_5)" size="mini"></el-tag>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <div class="header">
                    <h1>{{ $t('Past Cases') }}</h1>
                </div>
                <div class="my-content">
                    <div class="grid-stack-item-content">
                        <patenkind-cases :patenkind_slug="$route.params.patenkind_slug"/>
                    </div>
                </div>
            </el-col>
    </el-row>
</template>
<script>
import PatenkindCases from "../Cases/PatenkindCases";
    export default {
        components: {
            PatenkindCases
        },
        data() {
            return {
                patenkindDetails: {}
            };
        },
        mounted() {
            request({
                    url: "patenkinders/" + this.$route.params.patenkind_slug,
                    method: "get",
                    params: {}
                })
                .then(response => {
                    this.patenkindDetails = response.data.data;
                })
                .catch(error => {

                });
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Layout/Patenkinder/PatenkindDetails.vue